import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { NgIf } from '@angular/common';
import {
  AbnSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/abn-search/abn-search.component';
import {DataHandlerService} from '../../../services/data-handler.service';

@Component({
    selector: 'app-abn-acn',
    templateUrl: 'abn-acn.component.html',
    standalone: true,
    imports: [NgIf, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatCheckboxModule, MatCheckboxModule,
      MatFormFieldModule, MatFormFieldModule, ValidationPartialComponent, AbnSearchComponent]
})
export class AbnAcnComponent extends WizardWidgetComponent implements OnInit {
  @Input() public isPersonalLoan: boolean; // true if personal, false if business, null if display all
  @Output() public outputSelectedCompany = new EventEmitter<any>();
  selectedCompany: any;
  abnResults: any;

  constructor(public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  selectAbnRecord(record) {
    this.selectedCompany = record;
    this.outputSelectedCompany.next(record);
  }
}
